// An icon is the pair (icontype, icon):
//   icontype 'sdk' -> falcon-sdk sport icon, name from its SPORT_ICON_NAMES
//   icontype 'mui' -> @mui/icons-material component name
// See components/Icons/SportIcon.jsx for both vocabularies. The falcon-sdk set is
// preferred; MUI fills the gaps for the sports it does not draw.
//
// A customer can override any of these entries, or add their own, from
// Asetukset -> Lajit ja aktiviteettityypit (config/sports, config/activitytypes).
export const DEFAULT_SPORTS = [
  { key: 'tennis', label: 'Tennis', icon: 'tennis', icontype: 'sdk' },
  { key: 'padel', label: 'Padel', icon: 'padel', icontype: 'sdk' },
  { key: 'sulkapallo', label: 'Sulkapallo', icon: 'badminton', icontype: 'sdk' },
  { key: 'squash', label: 'Squash', icon: 'squash', icontype: 'sdk' },
  { key: 'pingis', label: 'Pingis', icon: 'tabletennis', icontype: 'sdk' },
  { key: 'biljardi', label: 'Biljardi', icon: 'billiard', icontype: 'sdk' },
  { key: 'petanque', label: 'Petanque', icon: 'SportsBaseball', icontype: 'mui' },
  { key: 'keilaus', label: 'Keilaus', icon: 'SportsBaseball', icontype: 'mui' },
  { key: 'curling', label: 'Curling', icon: 'AcUnit', icontype: 'mui' },
  { key: 'darts', label: 'Darts', icon: 'GpsFixed', icontype: 'mui' },
  { key: 'jousiammunta', label: 'Jousiammunta', icon: 'GpsFixed', icontype: 'mui' },
  { key: 'pickleball', label: 'Pickleball', icon: 'pickleball', icontype: 'sdk' },
  { key: 'jalkapallo', label: 'Jalkapallo', icon: 'football', icontype: 'sdk' },
  { key: 'koripallo', label: 'Koripallo', icon: 'basketball', icontype: 'sdk' },
  { key: 'salibandy', label: 'Salibandy', icon: 'floorball', icontype: 'sdk' },
  { key: 'lentopallo', label: 'Lentopallo', icon: 'volleyball', icontype: 'sdk' },
  { key: 'kuntosali', label: 'Kuntosali', icon: 'gym', icontype: 'sdk' },
  { key: 'kuntonyrkkeily', label: 'Kuntonyrkkeily', icon: 'boxing', icontype: 'sdk' },
  { key: 'ryhmaliikunta', label: 'Ryhmäliikunta', icon: 'gymnastics', icontype: 'sdk' },
  { key: 'beachvolley', label: 'Beach volley', icon: 'beachvolley', icontype: 'sdk' },
  { key: 'golf', label: 'Golf', icon: 'golf', icontype: 'sdk' },
  { key: 'jääkiekko', label: 'Jääkiekko', icon: 'icehockey', icontype: 'sdk' },
  { key: 'luistelu', label: 'Luistelu', icon: 'Skateboarding', icontype: 'mui' },
  { key: 'uinti', label: 'Uinti', icon: 'Pool', icontype: 'mui' },
  { key: 'sukellus', label: 'Sukellus', icon: 'ScubaDiving', icontype: 'mui' },
  { key: 'ratsastus', label: 'Ratsastus', icon: 'Sports', icontype: 'mui' },
  { key: 'hiihto', label: 'Hiihto', icon: 'Snowshoeing', icontype: 'mui' },
  { key: 'laskettelu', label: 'Laskettelu', icon: 'DownhillSkiing', icontype: 'mui' },
  { key: 'pyöräily', label: 'Pyöräily', icon: 'DirectionsBike', icontype: 'mui' },
  { key: 'juoksu', label: 'Juoksu', icon: 'trackandfield', icontype: 'sdk' },
  { key: 'kävely', label: 'Kävely', icon: 'DirectionsWalk', icontype: 'mui' },
  { key: 'melonta', label: 'Melonta', icon: 'Kayaking', icontype: 'mui' },
  { key: 'soutu', label: 'Soutu', icon: 'Rowing', icontype: 'mui' },
  { key: 'purjehdus', label: 'Purjehdus', icon: 'Sailing', icontype: 'mui' },
  { key: 'purjelautailu', label: 'Purjelautailu', icon: 'Kitesurfing', icontype: 'mui' },
  { key: 'kajakki', label: 'Kajakki', icon: 'Kayaking', icontype: 'mui' },
  { key: 'sähly', label: 'Sähly', icon: 'floorball', icontype: 'sdk' },
  { key: 'frisbeegolf', label: 'Frisbeegolf', icon: 'GolfCourse', icontype: 'mui' },
  { key: 'pilates', label: 'Pilates', icon: 'SelfImprovement', icontype: 'mui' },
  { key: 'muu', label: 'Muu', icon: 'Sports', icontype: 'mui' },
]

// falcon-sdk draws no activity type icons, so these are all MUI.
export const DEFAULT_TYPES = [
  { key: 'valmennus', label: 'Valmennus', icon: 'Sports', icontype: 'mui' },
  { key: 'kilpailu', label: 'Kilpailu', icon: 'SportsScore', icontype: 'mui' },
  { key: 'peli', label: 'Peli', icon: 'Groups', icontype: 'mui' },
  { key: 'tapahtuma', label: 'Tapahtuma', icon: 'Event', icontype: 'mui' },
  { key: 'kurssi', label: 'Kurssi', icon: 'School', icontype: 'mui' },
]

export const SERVICES = [
  { value: 'lang-fi', labels: { fi: 'Suomenkielinen palvelu' } },
  { value: 'lang-en', labels: { fi: 'Englanninkielinen palvelu' } },
  { value: 'lang-se', labels: { fi: 'Ruotsinkielinen palvelu' } },
  { value: 'public-transport', labels: { fi: 'Julkinen liikenne' } },
  { value: 'parking', labels: { fi: 'Pysäköinti' } },
  { value: 'free-parking', labels: { fi: 'Ilmainen pysäköinti' } },
  { value: 'wifi', labels: { fi: 'WiFi' } },
  { value: 'free-wifi', labels: { fi: 'Ilmainen WiFi' } },
  { value: 'cafe', labels: { fi: 'Kahvila' } },
  { value: 'restaurant', labels: { fi: 'Ravintola' } },
  { value: 'bar', labels: { fi: 'Baari' } },
  { value: 'showers', labels: { fi: 'Suihkut' } },
  { value: 'lockers', labels: { fi: 'Lokerot' } },
  { value: 'equipment-rental', labels: { fi: 'Välinevuokraus' } },
  { value: 'sauna', labels: { fi: 'Sauna' } },
  { value: 'gym', labels: { fi: 'Kuntosali' } },
  { value: 'spa', labels: { fi: 'Kylpylä' } },
  { value: 'accessible', labels: { fi: 'Esteetön' } },
  { value: 'change-rooms', labels: { fi: 'Pukuhuoneet' } },
  { value: 'first-aid', labels: { fi: 'Ensiapu' } },
  { value: 'defibrillator', labels: { fi: 'Defibrillaattori' } },
  { value: 'parking-electric', labels: { fi: 'Sähköauton lataus' } },
  { value: 'towel-rental', labels: { fi: 'Pyyhevuokraus' } },
  { value: 'proshop', labels: { fi: 'ProShop' } },
  { value: 'vending-soda', labels: { fi: 'Virvoitusjuoma-automaatti' } },
  { value: 'vending-snacks', labels: { fi: 'Välipala-automaatti' } },
  { value: 'vending-coffee', labels: { fi: 'Kahviautomaatti' } },
  { value: 'reception', labels: { fi: 'Vastaanotto' } },
  { value: 'massage', labels: { fi: 'Hieronta' } },
  { value: 'childcare', labels: { fi: 'Lastenhoito' } },
  { value: 'terrace', labels: { fi: 'Terassi' } },
  { value: 'racket-maintenance', labels: { fi: 'Mailahuolto' } },
].sort((a, b) => a.labels.fi.localeCompare(b.labels.fi, 'fi', { sensitivity: 'base' }))